var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-table',{attrs:{"rows":_vm.rows,"columns":_vm.columns,"equal-width":_vm.equalWidth,"empty-message":"No access logs to display"},on:{"sort":_vm.handleSort}})}
var staticRenderFns = []

export { render, staticRenderFns }